<template>
  <div class="row" tabindex="1" ref="container">
    <!--<div class="col-md-12">-->
    <!--<h4 class="title">Custom table with pagination</h4>-->
    <!--<p class="category">-->
    <!--We combine <a href="http://element.eleme.io/#/en-US/component/quickstart" target="_blank">Element-UI</a>-->
    <!--table functionalities together with a custom pagination component-->
    <!--which should provide a very good starting point to integrate tables in your application.-->
    <!--Check out more functionalities at <a href="http://element.eleme.io/#/en-US/component/table" target="_blank">Element-UI table documentation</a>.-->
    <!--</p>-->
    <!--</div>-->
    <div :class="embedded ? '' : 'col-md-12 card'">
      <!--<div class="card-header">-->
      <!--<div class="category">Extended tables</div>-->
      <!--</div>-->
      <div v-loading="loading || !schema_" :element-loading-text="i18n.fr('loading')">
        <div v-if="schema_" :class="embedded ? '' : 'card-content row'">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            <button type="button" class="btn"
                    :title="i18n.fr('action.reload')"
                    @click="fetchData"><i class="ti-reload" :class="{'ti-spin': loading}"></i>
              {{i18n.fr('action.reload')}}
            </button>
            <template v-if="listActions !== false">
              <button v-if="typeof schema_.create === 'function'" class="btn"
                      @click="handleCreate">
                {{i18n.fr('create_schema_$name', {name: schema_.title.call(this, null, schema_)})}}
              </button>
              <button v-for="btn in listActions_" class="btn" @click="handleAction(btn)">
                {{i18n.fr(btn.label)}}
              </button>
            </template>
            <span v-show="loading" style="text-align: center; font-size: 1.5em;"
                  v-html="i18n.f('html.loading')"></span>
          </div>
          <div class="col-sm-6 clearfix">
            <div class="pull-right">
              <!--<label>{{i18n.fr('action.show_inactive')}}-->
              <!--<p-switch v-model="filterInactive"></p-switch>-->
              <!--</label>-->
              <template v-for="i in tableFilters">
                <render v-if="typeof i === 'function'" :render="i"/>
                <render v-else-if="i.component" :component="i.component" :data="i.data"/>
              </template>
              <label>
                <input ref="search"
                       type="search" class="form-control input-sm"
                       :placeholder="i18n.fr('search_records_placeholder')"
                       v-model="searchQuery"
                       aria-controls="datatables">
              </label>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table class="table table-striped table-no-bordered table-hover"
                      ref="table"
                      :data="tableData"
                      v-if="!hideTable"
                      border
                      style="width: 100%"
                      :highlight-current-row="selectable"
                      :row-style="rowStyle"
                      :row-class-name="rowClassName"
                      @row-click="handleView"
                      @sort-change="sortChanged"
                      @filter-change="filterChanged"
                      @selection-change="e => $emit('selection-change', e)"
            >
              <el-table-column :resizable="true">
                <template scope="scope">
                  <span :title="rowId(scope)">{{rowTitle(scope)}}</span>
                </template>
              </el-table-column>
              <template v-for="column in displayColumns">
                <el-table-column v-if="typeof column.display === 'function'"
                                 :prop="column.prop"
                                 :column-key="column.prop"
                                 :label="column.label"
                                 :resizable="true"
                                 :filters="columnFilters[column.prop]"
                                 :filter-method="columnFilterFn(column)"
                                 :sortable="column.sortable !== false">
                  <template scope="scope">
                    <render :auto="renderField(column, scope)"></render>
                  </template>
                </el-table-column>
                <el-table-column v-else
                                 :prop="column.prop"
                                 :column-key="column.prop"
                                 :label="column.label"
                                 :resizable="true"
                                 :filters="columnFilters[column.prop]"
                                 :filter-method="columnFilterFn(column)"
                                 :sortable="column.sortable !== false">
                </el-table-column>
              </template>
              <!--<el-table-column-->
              <!--label="Actions">-->
              <!--<template scope="props">-->
              <!--<a class="btn btn-simple btn-xs btn-info btn-icon"-->
              <!--@click="handleView(props)"><i class="ti-new-window"></i></a>-->
              <!--<a v-if="typeof schema['edit'] === 'function'" class="btn btn-simple btn-xs btn-warning btn-icon edit"-->
              <!--title="Edit"-->
              <!--@click="handleEdit(props)"><i class="ti-pencil-alt"></i></a>-->
              <!--<a v-if="typeof schema['delete'] === 'function'"-->
              <!--class="btn btn-simple btn-xs btn-danger btn-icon remove" title="Delete"-->
              <!--@click="handleDelete(props)"><i class="ti-close"></i></a>-->
              <!--</template>-->
              <!--</el-table-column>-->
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">{{i18n.f('pagination_footer', {from: from + 1, to: to, total:
              pagination.total})}}</p>
          </div>
          <div class="col-sm-6 clearfix">
            <p-pagination class="pull-right" ref="pagination"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import {map, debounce, filter, get, isArray, remove, sortBy} from 'lodash';
  import Render from 'src/components/UIComponents/Render';
  import i18n from 'src/i18n/index';
  import {findKeyField, getField} from 'src/schemas/utils';
  import PSwitch from 'src/components/UIComponents/Switch.vue';
  import {parseError} from 'src/utils';
  import debug from 'src/debug';

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Select);
  Vue.use(Option);
  export default {
    components: {
      PPagination,
      Render,
      PSwitch,
    },
    props: {
      schema: {type: [Object, Promise, Function], required: true},
      initialFilter: {type: Object},
      embedded: {type: Boolean},
      selectable: {type: Boolean},
      perPage: {type: Number},
      rowStyle: {},
      rowClassName: {},
      listActions: {type: Boolean, default: true},
    },
    data() {
      return {
        schema_: null,
        loading: false,
        hideTable: false,
        pagination: {
          perPage: debug.DEBUG
            ? Math.max(1, this.perPage || parseInt(window.localStorage['pagination.perPage'])) || 20
            : 20,
          currentPage: 1,
          perPageOptions: [10, 20, 50, 100, 1000],
          total: 0,
        },
        sort: {},
        searchQuery: '',
        tableData: [],
        columnFilters: {},
        tableFilters: [],
        schemaParams: {}, // private data for schema use
      };
    },
    mounted() {
      this.reload();
      if (this.$bus) this.$bus.$on('search', this.searchChanged);
      document.body.addEventListener('keydown', this.keyEvent);
      this.$refs.container.addEventListener('keydown', this.keyEvent);
    },
    beforeDestroy() {
      if (this.$bus) this.$bus.$off('search', this.searchChanged);
      document.body.removeEventListener('keydown', this.keyEvent);
      this.$refs.container.removeEventListener('keydown', this.keyEvent);
    },
    computed: {
      listActions_() {
        let temp = typeof this.schema_.listActions === 'function'
          ? this.schema_.listActions.call(this, this.schema_)
          : this.schema_.listActions;
        return temp || [];
      },
      columns() {
        let temp = typeof this.schema_.columns === 'function'
          ? this.schema_.columns.call(this, null, this.schema_, true, true)
          : this.schema_.columns;
        return temp || [];
      },
      displayColumns() {
        return sortBy(filter(this.columns, x => x.list !== false), x => x.list);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.pagination.total < highBound) {
          highBound = this.pagination.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
//      filterInactive: {
//        get() {
//          if (this.$refs.table) {
//            for (let c of this.$refs.table.store.states.columns) {
//              if (c.columnKey === 'status') {
//                return c.filteredValue.indexOf('inactive');
//              }
//            }
//          }
//          return false;
//        },
//        set(v) {
//          if (this.$refs.table) {
//            for (let c of this.$refs.table.store.states.columns) {
//              if (c.columnKey === 'status') {
//                let temp = [].concat(c.filteredValue);
//                if (v) {
//                  temp.push('inactive');
//                } else {
//                  remove(temp, x => x === 'inactive');
//                }
//                this.$refs.table.store.commit('filterChange', {column: c, filters: temp});
//                break;
//              }
//            }
//          }
//        },
//      },
    },
    methods: {
      keyEvent(e) {
        if ((e.target == document.body && !this.embedded) || e.target == this.$refs.container) {
          this._keyEvent(e);
        }
      },
      _keyEvent(e) {
        if (!e.ctrlKey && !e.altKey && !e.metaKey) {
          if (e.keyCode == 39) {
            this.$refs.pagination.nextPage();
            e.stopPropagation();
          } else if (e.keyCode == 37) {
            this.$refs.pagination.prevPage();
            e.stopPropagation();
          } else if (/^[a-z0-9 ,<.>/?`~[{\\|\]}'";:=+\-_]$/i.test(e.key)) {
            this.$refs.search.focus();
            e.stopPropagation();
          }
        }
      },
      rowTitle(scope) {
        return this.schema_.title.call(this, scope.row, this.schema_);
      },
      rowId(scope) {
        let spec = findKeyField(this.columns);
        return getField.call(this, scope.row, spec);
      },
      renderField(spec, scope) {
        return spec.display.call(this, scope.row, scope.$index, spec, this.schema_, this.columns);
      },
      handleAction(btn) {
        btn.action.call(this, this.schema_, this.columns)
          .then(refresh => {
            if (refresh) {
              this.fetchData();
            }
          })
          .catch(err => {
            err = parseError(err);
            this.$notify({
              component: {
                template: `<span>${err}</span>`,
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
            });
          });
      },
      handleCreate() {
        this.schema_.create.call(this, this.schema_, this.columns)
          .catch(err => {
            err = parseError(err);
            this.$notify({
              component: {
                template: i18n.f('alert.html.$err', {err}),
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
            });
          });
      },
      handleView(row) {
        if (typeof this.schema_.view === 'function') {
          let p = this.schema_.view.call(this, row, 0, this.schema_, this.columns);
          if (p && typeof p.catch === 'function') {
            p.catch(err => {
              err = parseError(err);
              this.$notify({
                component: {
                  template: i18n.f('alert.html.$err', {err}),
                },
                icon: 'ti-alert',
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger',
              });
            });
          }
        }
      },
      handleEdit(scope) {
        let p = this.schema_.edit.call(this, scope.row, scope.$index, this.schema_, this.columns);
        if (p && typeof p.then === 'function') {
          p.then(refresh => {
            if (refresh) {
              this.fetchData();
            }
            // no notify
          }).catch(err => {
            err = parseError(err);
            this.$notify({
              component: {
                template: `<span>Cannot edit item: ${err}</span>`,
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
            });
          });
        }
      },
      handleDelete(scope) {
        let p = this.schema_.delete.call(this, scope.row, scope.$index, this.schema_, this.columns);
        if (p && typeof p.then === 'function') {
          p.then(refresh => {
            if (refresh) {
              this.fetchData();
            }
            this.$notify({
              component: {
                template: `<p>Item deleted successfully</p>`,
              },
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success',
            });
          }).catch(err => {
            err = parseError(err);
            this.$notify({
              component: {
                template: `<p>Cannot delete item: ${err}</p>`,
              },
              icon: 'ti-alert',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
            });
          });
        }
      },
      setData(data, total) {
        this.tableData = data || [];
        this.$nextTick(() => {
          this.pagination.total = total || (data && data.length) || 0;
          this.pagination.currentPage = Math.max(1, Math.min(
            this.pagination.currentPage,
            Math.ceil(this.pagination.total / this.pagination.perPage)));
          this.$emit('dataChanged', data, total);
        });
      },
      async reload(keepData) {
        this.loading = true;
        this.hideTable = true; // this flag is to force regenerate the table component
        this.schema_ = await (typeof this.schema === 'function' ? this.schema.call(this) : this.schema);
        this.schemaParams = {};
        if (!keepData) {
          this.setData([], 0);
          this.searchQuery = '';
        }
//        this.filterInactive = false;
        this.columnFilters = {};
        if (this.schema_.tableFilters) {
          this.tableFilters = typeof this.schema_.tableFilters === 'function'
            ? await this.schema_.tableFilters.call(this, this.schema_)
            : this.schema_.tableFilters;
        } else {
          this.tableFilters = [];
        }
        await new Promise(ok => this.$nextTick(ok));
        if (!keepData) {
          this.fetchData();
        }
        this.reloadColumnFilters();
        this.hideTable = false;
        this.loading = false;
      },
      async reloadColumnFilters() {
        let filters = {};
        for (let c of this.displayColumns) {
          let p;
          if (isArray(c.filter)) {
            p = c.filter;
          } else if (typeof c.filter === 'function') {
            p = c.filter.call(this, c, this.schema_, this.columns);
          }
          if (p) {
            let options = await p;
            if (options) {
              filters[c.prop] =
                map(options, x => typeof x === 'object'
                  ? {text: i18n.fr(x.label), value: x.value}
                  : {text: x, value: x});
            }
          }
        }
        this.columnFilters = filters;
      },
      columnFilterFn(spec) {
        if (spec.filter) {
          return this.returnTrue;
        }
      },
      returnTrue: () => true,
      async fetchData() {
        this.loading = true;
        let payload = {
          ...this.initialFilter,
          skip: this.from,
          limit: this.pagination.perPage,
          sort: Object.keys(this.sort).length ? this.sort : null,
          search: this.searchQuery,
//          status: this.filterInactive ? "inactive" : "active",
        };
        if (this.$refs.table) {
          for (let c of this.$refs.table.store.states.columns) {
            if (c.filteredValue.length) {
              payload[c.columnKey] = c.filteredValue;
            }
          }
        }
        try {
          let response = await this.schema_.list.call(this, payload, this.schema_, this.columns);
          this.setData(response.data, response.total);
        } catch (err) {
          err = parseError(err);
          this.$notify({
            component: {
              template: i18n.fr('alert.html.cannot_fetch_list_$err', {err}),
            },
            icon: 'ti-alert',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
          });
        }
        this.loading = false;
      },
      queryChanged: debounce(function () {
        this.fetchData();
      }, 500, {maxWait: 2000}),
      sortChanged(column) {
        if (column.prop) {
          this.sort = {[column.prop]: column.order == 'descending' ? -1 : 1};
        } else {
          this.sort = {};
        }
        this.fetchData();
      },
      searchChanged(query) {
        this.searchQuery = query;
      },
      filterChanged() {
        this.fetchData();
      },
    },
    watch: {
      schema() {
        this.reload();
      },
      searchQuery() {
        this.queryChanged();
      },
      // filterInactive() {
      //   this.fetchData();
      // },
      'pagination.perPage'() {
        window.localStorage['pagination.perPage'] = this.pagination.perPage;
        this.fetchData();
      },
      'pagination.currentPage'() {
        this.fetchData();
      },
      'i18n.local'() {
        this.reload(true);
      },
    },
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// SchemaBaseTable.vue?5305071a